<kal-form-field class="without-label">
  <kal-input id="user_superadmin__searchbar"
             label="Recherche"
             placeholder="Organisation, nom du CSE, ..."
             icon="search"
             [formControl]="control">
  </kal-input>
</kal-form-field>

<kal-list id="user_superadmin_ce_list"
          tabindex="1"
          [icon]="null"
          [dataSource]="displayedCEList"
          (selectionChange)="selectRow($event)">

  <ng-template kalListItem let-item="item">

    <span>{{ item.NomBase }}</span>
    <span>{{ item.InitialCatalog }}</span>

  </ng-template>

</kal-list>

<div class="gup-O-list gup-C-validationArea">

    <div class="gup-O-list__item">

        <kal-button id="user_superadmin_submit_dialog"
                    kalTheme="primary"
                    [disabled]="selection.isEmpty()"
                    (click)="submitDialog()">
            Sélectionner
        </kal-button>

    </div>

  <div class="gup-O-list__item">

    <kal-button id="user_superadmin_close_dialog"
                kalTheme="secondary"
                (click)="closeDialog()">
      Fermer
    </kal-button>

  </div>

</div>
